import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsOfService: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
    <div style={{
      minHeight: '100vh',
      background: '#f5f5f5',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
    }}>

      {/* Content */}
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '48px 24px'
      }}>
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '48px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
        }}>
          <h1 style={{
            fontSize: '36px',
            fontWeight: '700',
            color: '#1a3a52',
            marginBottom: '8px'
          }}>
            Terms Of Service
          </h1>
          
          <p style={{
            fontSize: '14px',
            color: '#666',
            marginBottom: '32px'
          }}>
            Last Updated: November 28, 2024
          </p>

          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginBottom: '32px'
          }}>
            Welcome to Scriblish! By using our platform, you agree to these Terms of Service. Please read them carefully.
          </p>

          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#1a3a52',
            marginTop: '32px',
            marginBottom: '16px'
          }}>
            1. Account Requirements
          </h2>
          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginBottom: '24px'
          }}>
            Scriblish is designed for children ages 8-12. Users under 13 require parental consent to create an account. We comply with COPPA (Children's Online Privacy Protection Act) regulations.
          </p>

          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#1a3a52',
            marginTop: '32px',
            marginBottom: '16px'
          }}>
            2. Acceptable Use
          </h2>
          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginBottom: '16px'
          }}>
            Users agree to:
          </p>
          <ul style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginLeft: '24px',
            marginBottom: '24px'
          }}>
            <li style={{ marginBottom: '8px' }}>Create original content or properly attribute sources</li>
            <li style={{ marginBottom: '8px' }}>Treat other users with kindness and respect</li>
            <li style={{ marginBottom: '8px' }}>Follow our Community Guidelines</li>
            <li style={{ marginBottom: '8px' }}>Not share personal information (full name, address, phone number, school name)</li>
            <li style={{ marginBottom: '8px' }}>Not upload inappropriate, hateful, or harmful content</li>
          </ul>

          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#1a3a52',
            marginTop: '32px',
            marginBottom: '16px'
          }}>
            3. Content Moderation
          </h2>
          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginBottom: '24px'
          }}>
            All published stories are screened through our AI Safety Filter. We reserve the right to remove content that violates our guidelines or Terms of Service. Accounts that repeatedly violate our policies may be suspended or terminated.
          </p>

          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#1a3a52',
            marginTop: '32px',
            marginBottom: '16px'
          }}>
            4. Intellectual Property
          </h2>
          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginBottom: '24px'
          }}>
            You retain ownership of the stories you create on Scriblish. By publishing your work, you grant Scriblish a non-exclusive license to display your content on our platform. We will never sell or use your stories for commercial purposes without your permission.
          </p>

          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#1a3a52',
            marginTop: '32px',
            marginBottom: '16px'
          }}>
            5. Account Termination
          </h2>
          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginBottom: '24px'
          }}>
            You may delete your account at any time through your account settings. We reserve the right to suspend or terminate accounts that violate these Terms of Service.
          </p>

          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#1a3a52',
            marginTop: '32px',
            marginBottom: '16px'
          }}>
            6. Limitation of Liability
          </h2>
          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginBottom: '24px'
          }}>
            Scriblish is provided "as is" without warranties of any kind. We are not liable for any damages arising from your use of the platform.
          </p>

          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#1a3a52',
            marginTop: '32px',
            marginBottom: '16px'
          }}>
            7. Changes to Terms
          </h2>
          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginBottom: '24px'
          }}>
            We may update these Terms of Service from time to time. Continued use of Scriblish after changes are posted constitutes acceptance of the updated terms.
          </p>

          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#1a3a52',
            marginTop: '32px',
            marginBottom: '16px'
          }}>
            8. Contact Us
          </h2>
          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginBottom: '0'
          }}>
            If you have questions about these Terms of Service, please contact us at{' '}
            <a 
              href="mailto:scriblishofficial@gmail.com"
              style={{ color: '#6C5CE7', textDecoration: 'none', fontWeight: '600' }}
            >
              scriblishofficial@gmail.com
            </a>
          </p>

     {/* Related Pages */}
     <div style={{
            marginTop: '48px',
            paddingTop: '32px',
            borderTop: '1px solid #e5e5e5',
            textAlign: 'center'
          }}>
            <p style={{ fontSize: '14px', color: '#666', marginBottom: '16px' }}>
              More Information
            </p>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <a href="/about" style={{ color: '#6C5CE7', textDecoration: 'none', fontSize: '14px' }}>About</a>
              <a href="/privacy-policy" style={{ color: '#6C5CE7', textDecoration: 'none', fontSize: '14px' }}>Privacy Policy</a>
              <a href="/community-guidelines" style={{ color: '#6C5CE7', textDecoration: 'none', fontSize: '14px' }}>Community Guidelines</a>
              <a href="/contact" style={{ color: '#6C5CE7', textDecoration: 'none', fontSize: '14px' }}>Contact Us</a>
            </div>
          </div>
        </div>  {/* ← closes white card */}
      </div>  {/* ← closes padding container */}
    </div>  {/* ← closes outer container */}
    </> 
  );
};

export default TermsOfService;
